import {projectCode} from "../resources/constants";

export const setGeneralDetails = (p) => {
    return {
        type: "SET_GENERALDETAILS_DETAILS",
        payload: p,
    };
};

export const setPermissionDetails = (p) => {
    return {
        type: "SET_PERMISSION_DATA",
        payload: p,
    };
};

export const setLoginDetails = (p) => {
    return {
        type: "SET_LOGIN_DETAILS",
        payload: p,
    };
};

export const setApplicationDetails = (p) => {
    return {
        type: "SET_APPLICATION_DETAILS",
        payload: p,
    };
};

export const setApplicationRequirementDetails = (p) => {
    return {
        type: `SET_${projectCode}_APPLICATION_REQUIREMENT_DETAILS`,
        payload: p,
    };
};

export const setJambRequirementDetails = (p) => {
    return {
        type: `SET_${projectCode}_JAMB_REQUIREMENT_DETAILS`,
        payload: p,
    };
};

export const setOLevelRequirementDetails = (p) => {
    return {
        type: `SET_${projectCode}_OLevel_REQUIREMENT_DETAILS`,
        payload: p,
    };
};
